import React, {useEffect, useState} from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import {useGetRequest} from '../../../hooks/useGetRequest/useGetRequest';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';

import {
    initialAllOptionPromises,
    isNullOrUndefinded,
    jsonNoEstaVacio,
    updateFiltersWithExtraData
} from '../../../helper/utils';
import {
    getAllCargosAPI,
    getAllEstadosAPI,
    getAllSedesAPI,
    getAllAreasAPI,
    getMainFiltrosListarMisDocumentosAPI,
    getListaAdminFlujoDocumentoEmpleadosAPI,
    getFlujoDocumentosAlosQueTengoAccesosAPI,
    getAllFlujoDocumentoPasosAPI,
    cargarNuevosIngresosAPI, descargarFormatoCargaNuevosIngresosAPI, cargarFormatoEmpleadosSinCodigoOfisisAPI,
    descargarFormatoEmpleadosSinCodigoOfisisAPI
} from "../../../consumers/backendApisUrls";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import Select from "react-select";
import styled from "styled-components";
import ModalEnabled from "../../../components/modalComponents/ModalEnabled";
import AdminTableFlujoDocumentoEmpleado from "./AdminTableFlujoDocumentoEmpleado";
import {Div} from "../../registroMaternidad/modales/components/Components";
import PageButtons from "../../../components/pageComponents/PageButtons";
import RegistrarFalta from "../../Faltas/ListarSolicitudes/modales/RegistrarFalta";
import {NavDropdown} from "react-bootstrap";
import DeclararNoTengoFaltas from "../../Faltas/ListarSolicitudes/modales/DeclararNoTengoFaltas";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import CrearListaDocumentos from "../../gestionNuevosIngresos/configurarListaDocumentos/modales/CrearListaDocumentos";
import ImportFileGenericModal from "../../../components/modal/ImportFileGenericModal";
import RegistrarFlujoDocumentoEmpleado from "./modales/RegistrarFlujoDocumentoEmpleado";

const INIT_KEYS = {
    IdsSedes: "IdsSedes",
    IdsAreas: "IdsAreas",
    IdsCargos: "IdsCargos",
    IdsEstados: "IdsEstados",
    IdsPasos: "IdsPasos",
};

const AdminFlujoDocumentoEmpleados = () => {
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);

    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const [flujoDocumentos, setFlujoDocumentos] = useState([]);
    const [selectedFlujoDocumento, setSelectedFlujoDocumento] = useState({});

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllSedesAPI()),
            executeGet(getAllAreasAPI()),
            executeGet(getAllCargosAPI()),
            response,
            executeGet(getAllFlujoDocumentoPasosAPI()),
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await getFiltrosGenerales();
            await manageSearch();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaAdminFlujoDocumentoEmpleadosAPI();

        if (selectedFlujoDocumento?.value) {
            const payload = getPayload();
            await executeManagePost(api, payload, successManageSearchCallback);
        }

        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdFlujoDocumento: selectedFlujoDocumento?.value,
            ...formValues.selectedFilters
        }
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const getFiltrosGenerales = async () => {
        await executeManageGet(getFlujoDocumentosAlosQueTengoAccesosAPI(), (res) => getAllFlujoDocumentosAPICallback(res), false);
    }

    const getAllFlujoDocumentosAPICallback = ({data}) => {
        const items = data.map(o => ({value: o.Value, label: o.Text}));
        setFlujoDocumentos(items);
        if (items.length > 0)
            setSelectedFlujoDocumento(items[0])
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters, selectedFlujoDocumento?.value])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();

    }, [])


    return (
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Admin Documentos"/>
            <div className="displayFlexWrap">
                <SelectMainFiltros items={flujoDocumentos} selectedItem={selectedFlujoDocumento}
                                   setSelectedItem={setSelectedFlujoDocumento}/>
            </div>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <div className="d-flex">

                        <PageButtons>
                            {!isNullOrUndefinded(selectedFlujoDocumento?.value) && formValues?.ExtraData?.PuedeCrear === true &&
                                <button
                                    type="button"
                                    className="generic-button-buscador"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: RegistrarFlujoDocumentoEmpleado,
                                            data: {
                                                idFlujoDocumento: selectedFlujoDocumento?.value
                                            }
                                        })
                                    }
                                >
                                    Agregar Empleado
                                </button>
                            }


                            <NavDropdown id={"navDropdown-configuracion"}
                                         className=""
                                         title={<span className="align-items-center p-2 ml-2"
                                                      style={{backgroundColor: 'gray', borderRadius: '50%'}}
                                                      onClick={() => {
                                                      }}
                                         >


                                                 <FontAwesomeIcon icon='cog' size="lg" className="hand-pointer white"
                                                                  style={{color: 'white'}}
                                                                  title="Configurar"/>
                                                 </span>}>
                                <Link
                                    to="/gestionDeDocumentos"
                                    className="dropdown-item">
                                    Configurar Documentos
                                </Link>
                            </NavDropdown>
                        </PageButtons>
                    </div>
                </ButtonsWrapper>
            </SearchContainer>

            <AdminTableFlujoDocumentoEmpleado
                formValues={formValues}
                setFormValues={setFormValues}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                fromAdminPage={true}
                manageSearch={manageSearch}
            />
        </PageWrapper>
    );
}

export default AdminFlujoDocumentoEmpleados;

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;

const SelectMainFiltros = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({...res})}
            placeholder="Seleccionar "
        />
    </div>
)
